const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcgMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMi40OTE3MSA2LjAwMDA0TDYuNzQ1OSAxMC4yNTQyTDUuOTIwOTQgMTEuMDc5MkwwLjg0MTc5NyA2LjAwMDA0TDUuOTIwOTQgMC45MjA4OThMNi43NDU5IDEuNzQ1ODZMMi40OTE3MSA2LjAwMDA0WiIgZmlsbD0iIzk3QTFBQiIvPgo8L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=arrow-left-1fd6565e.mjs.map
